module.exports = __webpack_public_path__ + "img/AftaSansThin-Regular.2065bdbb.svg";